import from from './from.js'; // lol
import of from './of.js';
// the statics Class gives Matreshka.Array
export default {
  of: of,
  from: from
};